import React, {Component} from "react";
import VerticalTabs from "./VerticalTabs";
import PlayerReport from "./scouting_reports_tab_base/PlayerReport";
import PlayerCard from "./scouting_reports_tab_base/PlayerCard";

import '../../../assets/sass/global/tabs/scouting-reports-tab-base/player-card.scss';

import annFloresAvatar from "../../../assets/img/demo/ann-flores-avatar.png";
import darrellMckinneyAvatar from "../../../assets/img/demo/darrell-mckinney-avatar.png";

const player1 = {
    name: 'Ann Flores',
    teamName: 'Real Madrid',
    score: 87,
    datetime: '31 Jan 2019',
    avatar: annFloresAvatar,
};
const player2 = {
    name: 'darrell Mckinney',
    teamName: 'Lever Ball',
    score: 87,
    datetime: '31 Jan 2019',
    avatar: darrellMckinneyAvatar,
};
const items = Array.from(Array(10).keys()).map(i => (i % 2 === 1 ? player1 : player2));

class ScoutingReportsTabBase extends Component {
    render = () => {
        return (
            <div className="scouting-reports-tab">
                {this.renderContent()}
            </div>
        );
    };

    /**
     * Renders extra header tab.
     * @returns {React.ReactNode} The page content.
     */
    renderExtraTabsController = {
        topComponent: null,
    }

    /**
     * Renders the content of the page.
     * @returns {React.ReactNode} The page content.
     */
    renderContent = () => {
        const renderedItems = this.renderTabs(items);

        return (
            <VerticalTabs id="scouting-reports-tab" items={renderedItems} search={true} searchPlaceHolder="" renderExtraTabsController={this.renderExtraTabsController}/>
        );
    };

    renderTabs = (itemsData) => {
        return itemsData.map((itemData, index) => this.renderTab(index, itemData));
    };

    /**
     * Renders the header and content of the tab.
     * @param key {number} The unique key of the tab.
     * @param player {object} The player data.
     * @returns {{searchableFields: Array, header: React.ReactNode, key: number, content: React.ReactNode}} The rendered tabs.
     */
    renderTab = (key, player) => {
        return {
            key: key,
            header: this.renderPlayersCard(player),
            content: this.renderPlayerContent(player),
            searchableFields: this.searchableFields(player)
        };
    };

    /**
     * Renders the tab card component shown in the tab controller.
     * @abstract
     * @param player {object} The player object.
     * @returns {React.ReactNode} The player card.
     */
    renderPlayersCard = (player) => {
        return <ScoutingReportsTabBase.PlayerCard {...player}/>
        // return 'Abstract Player Card';
    };

    /**
     * Renders the content in the tab pane.
     * @abstract
     * @param player {object} The player object.
     * @returns {React.ReactNode} The content of tab pane .
     */
    renderPlayerContent = (player) => {
        return (<ScoutingReportsTabBase.PlayerReport {...player}/>);
        // return "Abstract Player Report";
    };

    /**
     * Returns the searchable fields.
     * @abstract
     * @param player {object} The player object.
     * @returns {Array}
     */
    searchableFields = (player) => {
        return [];
    };
}

ScoutingReportsTabBase.PlayerCard = PlayerCard;
ScoutingReportsTabBase.PlayerReport = PlayerReport;

export default ScoutingReportsTabBase;
